import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './LoginOption.scss';

const LoginOption = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="login-dropdown" ref={dropdownRef}>
        <div className="custom-btn-secondary login-button" onClick={toggleDropdown}>Login</div>
        {isOpen && (
        <div className='login-options'>
          {options.map((group, index) => (
            <div key={index} className='link-group'>
              <h3>{group.title}</h3>
              <ul>
                {group.links.map((link, idx) => (
                  <li key={idx}>
                    <Link to={link.to}>{link.label} <img src='/Assets/images/link-arrow.svg' alt='' /></Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>  
        )}     
      </div>
    </>
  );
};

export default LoginOption;
